module.exports = __webpack_public_path__ + "files/7bee1c7523dee573662d8007b34507d8.png";